<template>
    <div id="replace-member">
        <v-toolbar color="#8950FC">
            <v-toolbar-title>
                <h1 class="text-white">{{ pageDescription }}</h1>
            </v-toolbar-title>
            <v-spacer></v-spacer>
            <v-toolbar-items>
                <v-btn icon dark @click="closePrompt">
                    <v-icon>mdi-close</v-icon>
                </v-btn>
            </v-toolbar-items>
        </v-toolbar>
        <v-card>
            <v-card-text>
                <v-form ref="form" v-model="valid" lazy-validation>
                    <v-container>
                        <v-row wrap>
                            <v-col cols="12" sm="6" lg="4" md="4" align="center">
                                <v-img :src="record.ProfilePic" height="100px" width="100px" v-if="record.ProfilePic" />
                                <h6>{{ record.MembershipId }}</h6>
                                <h6>{{ record.MemberName }}</h6>
                            </v-col>
                        </v-row>
                        <v-row wrap>
                            <v-col cols="12" sm="6" lg="4" md="4">
                                <label>
                                    <h6><span class="text-danger">*</span> New Member ID</h6>
                                </label>
                                <v-text-field v-model="NewMemberId" :rules="NewMemberIdRules"
                                    placeholder="Enter new member ID" required outlined dense
                                    :append-icon="SearchFlag ? '' : 'mdi-magnify'" @click:append="fetchMemberDetails"
                                    @input="NewMemberDetails = {}" @keyup.enter="fetchMemberDetails">
                                    <template v-slot:append>
                                        <v-progress-circular v-if="SearchFlag" indeterminate size="20" width="2"
                                            color="#8950FC"></v-progress-circular>
                                        <v-icon v-else @click="fetchMemberDetails"
                                            style="cursor:pointer">mdi-magnify</v-icon>
                                    </template>
                                </v-text-field>
                            </v-col>
                        </v-row>
                        <v-row v-if="NewMemberDetails && NewMemberDetails.MembershipId" class="mt-3">
                            <v-col cols="12" sm="10" md="7" lg="5">
                                <v-card class="portal-details-card elevation-3">
                                    <div class="portal-card-header">
                                        <v-icon color="white" class="mr-2">mdi-shield-account</v-icon>
                                        <span class="portal-card-title">Portal Details</span>
                                        <v-chip x-small color="#e53935" text-color="white" class="ml-2">Member</v-chip>
                                    </div>
                                    <v-card-text class="pa-3">
                                        <div class="d-flex align-center" style="gap: 12px">
                                            <div class="flex-shrink-0 d-flex flex-column align-center"
                                                style="width: 80px">
                                                <v-avatar size="72" class="elevation-4">
                                                    <img :src="NewMemberDetails.MemberImage" alt="Profile" />
                                                </v-avatar>
                                                <div class="mt-1 text-center"
                                                    style="font-size: 10px; color: #666; word-break: break-word; max-width: 80px">
                                                    {{ NewMemberDetails.MembershipId || "N/A" }}
                                                </div>
                                            </div>
                                            <div class="flex-grow-1" style="min-width: 0">
                                                <div class="member-info-grid">
                                                    <div class="info-item">
                                                        <span class="info-label"><v-icon x-small
                                                                class="mr-1">mdi-account</v-icon>Name</span>
                                                        <span class="info-value">{{ NewMemberDetails.Fullname || "N/A"
                                                            }}</span>
                                                    </div>
                                                    <div class="info-item">
                                                        <span class="info-label"><v-icon x-small
                                                                class="mr-1">mdi-briefcase-outline</v-icon>Designation</span>
                                                        <span class="info-value">{{
                                                            NewMemberDetails.MemberDesignation || "N/A" }}</span>
                                                    </div>
                                                    <div class="info-item">
                                                        <span class="info-label"><v-icon x-small
                                                                class="mr-1">mdi-email-outline</v-icon>Email</span>
                                                        <span class="info-value text-truncate"
                                                            :title="NewMemberDetails.EmailId"
                                                            style="max-width: 180px; display: inline-block">{{
                                                                NewMemberDetails.EmailId || "N/A" }}</span>
                                                    </div>
                                                    <div class="info-item">
                                                        <span class="info-label"><v-icon x-small
                                                                class="mr-1">mdi-phone-outline</v-icon>Contact</span>
                                                        <span class="info-value">{{ NewMemberDetails.MobileNo || "N/A"
                                                            }}</span>
                                                    </div>
                                                </div>
                                                <div class="d-flex flex-wrap mt-2" style="gap: 6px">
                                                    <v-chip x-small
                                                        :color="NewMemberDetails.PhotoUpdate ? '#10b981' : '#f59e0b'"
                                                        text-color="white">
                                                        <v-icon left x-small>{{
                                                            NewMemberDetails.PhotoUpdate ? "mdi-check-circle" :
                                                                "mdi-clock-outline" }}</v-icon>
                                                        Photo: {{ NewMemberDetails.PhotoUpdate ? "Done" : "Pending" }}
                                                    </v-chip>
                                                    <v-chip x-small
                                                        :color="NewMemberDetails.AadhaarVerifiedFlag ? '#10b981' : '#f59e0b'"
                                                        text-color="white">
                                                        <v-icon left x-small>{{
                                                            NewMemberDetails.AadhaarVerifiedFlag ? "mdi-check-circle" :
                                                                "mdi-alert-circle" }}</v-icon>
                                                        {{ NewMemberDetails.AadhaarVerifiedTxt || "Not Verified" }}
                                                    </v-chip>
                                                </div>
                                            </div>
                                        </div>
                                    </v-card-text>
                                </v-card>
                            </v-col>
                        </v-row>
                        <v-row wrap>
                            <v-col align="center" cols="12" md="12">
                                <v-btn :disabled="!valid" @click.prevent="replaceRecord" :loading="ReplaceFlag"
                                    color="#8950FC" elevation="30" shaped tile large
                                    class="btn btn-primary font-size-h6 px-15 py-4 my-3 mr-3 white--text">
                                    Replace
                                </v-btn>
                                <v-btn @click.prevent="closePrompt" color="#00a4ef" elevation="30" shaped tile large
                                    class="btn btn-primary font-size-h6 px-15 py-4 my-3 mr-3 white--text">
                                    Cancel
                                </v-btn>
                            </v-col>
                        </v-row>
                    </v-container>
                </v-form>
            </v-card-text>
        </v-card>
    </div>
</template>

<script>
import common from "@/view/Common.vue";
import companyConfig from "@/company_config.json";

export default {
    mixins: [common],
    props: {
        pageDescription: {
            type: String,
            default: "Replace Member",
        },
        replaceRecordPrompt: {
            type: Boolean,
            default: false,
        },
        record: {
            type: Object,
            default: () => ({}),
        },
    },
    data() {
        return {
            valid: true,
            ReplaceFlag: false,
            SearchFlag: false,

            NewMemberId: "",
            NewMemberIdRules: [(v) => !!v || "New Member ID is required"],
            NewMemberDetails: {},
            member: {},
        };
    },
    methods: {
        fetchMemberDetails() {
            if (!this.NewMemberId) {
                this.sweetAlert("error", "Membership Id is required", false);
                return;
            }
            this.SearchFlag = true;
            this.NewMemberDetails = {};

            var server_url = companyConfig.apiURL;
            var token = this.$session.get("token");
            token = token == null ? 0 : token;
            var add_url = server_url + "api/members/search";
            var upload = {
                UserInterface: 2,
                MembershipId: this.NewMemberId,
            };

            const thisIns = this;

            this.$http({
                url: add_url,
                method: "POST",
                data: upload,
                headers: {
                    "Content-Type": "application/json",
                    Authorization: "Bearer " + token,
                },
            })
                .then(function (response) {
                    thisIns.SearchFlag = false;
                    var flag = response.data.flag;
                    var output = response.data.output;
                    var records = response.data.records;
                    if (flag == 1) {
                        thisIns.toast("success", output);
                        thisIns.NewMemberDetails = records;
                    } else {
                        thisIns.toast("error", output);
                    }
                })
                .catch(function (error) {
                    console.log("error=" + error);
                    thisIns.SearchFlag = false;
                });
        },
        closePrompt() {
            this.$emit("hideReplaceRecordPrompt");
        },

        replaceRecord() {
            if (this.$refs.form.validate()) {
                console.log("replaceRecord called");
                console.log({ record: this.record, NewMemberId: this.NewMemberId });
                this.ReplaceFlag = true;

                console.log("record=" + JSON.stringify(this.record));
                var server_url = companyConfig.apiURL;
                var token = this.$session.get("token");
                token = token == null ? 0 : token;
                var add_url = server_url + "api/senior-members/replace-old-membership";
                var upload = {
                    UserInterface: 1,
                    YearCode: this.record.YearCode,
                    OldMembershipId: this.record.MembershipId,
                    NewMemberShipId: this.NewMemberId,
                };
                console.log("upload=" + JSON.stringify(upload));

                const thisIns = this;
                var output = "";
                var flag = 0;

                this.$http({
                    url: add_url,
                    method: "POST",
                    data: upload,
                    headers: { Authorization: "Bearer " + token },
                    onUploadProgress: function (progressEvent) {
                        this.uploadPercentage = parseInt(
                            Math.round((progressEvent.loaded / progressEvent.total) * 100)
                        );
                    }.bind(this),
                })
                    .then(function (response) {
                        console.log("response=" + JSON.stringify(response));
                        thisIns.ReplaceFlag = false;
                        output = response.data.output;
                        flag = response.data.flag;
                        console.log("output=" + output + ", flag=" + flag);
                        if (flag == 1) {
                            thisIns.toast("success", output);
                            thisIns.closePrompt();
                        } else {
                            thisIns.toast("error", output);
                        }
                    })
                    .catch(function (error) {
                        console.log("error=" + error);
                        thisIns.ReplaceFlag = false;
                        thisIns.toast("error", error);
                    });
            }
        },
    },
};
</script>

<style scoped>
.portal-details-card {
    border-radius: 10px;
    overflow: hidden;
}

.portal-card-header {
    background: linear-gradient(135deg, #8950fc, #6610f2);
    padding: 10px 14px;
    display: flex;
    align-items: center;
}

.portal-card-title {
    color: white;
    font-weight: 600;
    font-size: 14px;
}

.member-info-grid {
    display: grid;
    grid-template-columns: 1fr 1fr;
    gap: 6px;
}

.info-item {
    display: flex;
    flex-direction: column;
}

.info-label {
    font-size: 10px;
    color: #888;
    display: flex;
    align-items: center;
}

.info-value {
    font-size: 12px;
    font-weight: 500;
    color: #333;
}
</style>
